<template>
  <div class="ms-auto d-flex" style="gap: 15px;">
    <CreateButton label="Neuer Interessenten" :to="{ name: 'unemployedPotentialForm' }" />

    <CreateButton label="Neuer Kunde" :to="{ name: 'unemployedForm' }" />
  </div>
</template>

<script setup>

import CreateButton from '@/components/CreateButton.vue';
</script>

<style scoped>

</style>